import * as React from 'react';

export interface ICardHealthRecordProps {
  healthRecord?: IEMRData;
  navigate?: (path: string, options?: Record<string, any>) => void;
  title?: string;
  isShowIcd?: boolean;
}

const PHRMobileMedicalRecordsItem: React.FC<ICardHealthRecordProps> = ({
  healthRecord,
  navigate,
  title,
  isShowIcd,
  ...props
}) => {
  return (
    <div
      className="bg-white w-full h-full rounded-lg shadow-md flex flex-col"
      onClick={() => {
        navigate &&
          navigate(`/phr-mobile/medical-records/detail/${healthRecord?.user?._id}`, {
            state: { uid: healthRecord?.user?._id, healthRecord: healthRecord, title },
          });
      }}
    >
      <span className="cms-h4 mt-4 mb-4 mx-4">{healthRecord?.user?.username ?? '---'}</span>
      {/* <span className="cms-body2 mb-4 mx-4">{day.format('hh:mm DD/MM/YYYY')}</span> */}
      <div className="flex flex-row items-center justify-between mb-2">
        <span className="cms-h5 text-gray-1 pl-4 pr-2 bg-mint-9 rounded-r-full">DVKT</span>
        <b className="cms-body2 mr-4">{healthRecord?.data?.service?.[0]?.data?.service?.length || 0}</b>
      </div>
      <div className="flex flex-row items-center justify-between mb-4">
        <span className="cms-h5 text-gray-1 pl-4 pr-2 bg-mint-9 rounded-r-full">Xét nghiệm</span>
        <b className="cms-body2 mr-4">{healthRecord?.data?.test?.[0]?.data?.test?.length || 0}</b>
      </div>

      {isShowIcd ? (
        <div className="px-4 pt-1 pb-4 bg-gray-2 rounded-b-lg border-t-2 border-gray-4">
          <span className="cms-h5 text-mint-9">Chẩn đoán</span>
          {healthRecord?.data?.icd?.map((icd: any, i: number) => {
            return (
              <div key={icd?._id ?? i.toString()} className="cms-body1 mt-1">
                {icd?.data?.icd?.label} | {icd?.data?.definiteDiagnosis}
              </div>
            );
          })}
        </div>
      ) : (
        <></>
      )}
    </div>
  );
};
export default PHRMobileMedicalRecordsItem;
